<template>
  <div v-if="visible">
    <div>{{ value.explain }}</div>
    <div
      v-for="(item,index) in value.option"
      :key="index"
      :style="{paddingTop: '10px',paddingRight:'30px'}"
    >
      <div :style="{fontSize: '17px',color: 'black'}">
        <a-row :gutter="48">
          <a-col :span="1">
            <span> {{ index + 1 }}.</span>
          </a-col>
          <a-col
            :span="22"
            :style="{fontSize: '17px',color: 'black',paddingLeft: '0px'}"
          >
            <span v-html="item.title"> {{ item.title }}</span>
          </a-col>
        </a-row>
      </div>
      <a-radio-group
        :style="{width:'100%'}"
        v-model="item.result"
        @change="onChange"
      >
        <a-row
          :gutter="48"
          v-for="(items, index2) in item.choiceList"
          :key="index2"
          :style="{height:'30px'}"
        >
          <a-col :span="24">
            <!-- <a-radio :value="items.key"><span :style="{fontSize: '16px'}">{{ items.key }} . {{ items.content }}</span></a-radio> -->
            <a-row :gutter="48">
              <a-col
                :span="2"
                :style="{paddingRight: '0px'}"
              >
                <a-radio :value="items.key">
                  <span :style="{fontSize: '17px',color: 'black'}"> {{ items.key }} .</span>
                </a-radio>
              </a-col>
              <a-col
                :span="22"
                :style="{fontSize: '17px',color: 'black',paddingLeft: '0px'}"
              >
                <span v-html="items.content"></span>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-radio-group>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SingleForm',
  data () {
    return {
      visible: false,
      value: {}
    }
  },
  created () {
    // console.log('数据详情：' + JSON.stringify(this.value))
  },
  methods: {
    handleOpen (value) {
      // console.log('数据详情：' + JSON.stringify(value))
      this.visible = true
      this.value = value
    },
    onChange () {
      this.$emit('resultChange', this.value)
    },
    handleClose () {
      this.visible = false
    }
  }
}
</script>
